import React from 'react';
import PropTypes from 'prop-types';
import { useTimezoneSelect, allTimezones } from 'react-timezone-select';
import { Box } from 'grommet';
import ProductFormDropdownSelect from './DropdownSelect';

const TimezoneSelect = ({
  value,
  handleFormValues,
  small = false,
}) => {
  const { options, parseTimezone } = useTimezoneSelect({ labelStyle: 'abbrev', allTimezones });

  const formattedTimezones = options.map(({ value: timezoneVal, label }) => ({
    api: timezoneVal,
    display: label,
  }));

  return (
    <Box justify="start" align="center" width="100%">
      <ProductFormDropdownSelect
        selectable
        small={small}
        inputConfig={{ overrideOptions: formattedTimezones }}
        handleFormValues={(val) => {
          const parsed = parseTimezone(val);
          handleFormValues(parsed.value);
        }}
        label={value}
        value={value}
        autoSelect={false}
      />
    </Box>
  );
};

TimezoneSelect.propTypes = {
  value: PropTypes.string,
  handleFormValues: PropTypes.func.isRequired,
  small: PropTypes.bool,
};

export default TimezoneSelect;
